export const POINT_EXCHANGES_FEATURE_KEY = "point_exchange";
